import Damage from "../../../../model/crew/Damage";
import BigNum from "../../../../model/math/BigNum";
import { Settings } from "../../../../Settings";
import NumberFormatter from "../../../../util/NumberFormatter";
import Page from "../../../framework/Page";
import View from "../../../framework/View";

export default class TotalDamageView extends View {
    /**
     * @param {string} parentId
     * @param {Damage} damage
     */
    constructor(parentId, damage) {
        super(parentId, parentId + '_tot');

        /**
         * @constant
         * @type {Damage}
         */
        this.damage = damage;

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedTotalDamage = new BigNum(0);
        /**
         * @type {string}
         */
        this.totalDamageString = null;

        /**
         * @constant
         * @type {BigNum}
         */
        this.workingNum = new BigNum(0);

        /**
         * We don't need to convert the turnsPerSecond number into a BigNum every single turn.
         * @constant
         * @type {BigNum}
         */
        this.turnsPerSecond = new BigNum(Settings.time.turnsPerSecond);

        /**
         * @type {HTMLElement}
         */
        this.baseTotalBody = null;

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {

        const parentElement = Page.getElement(this.parentId);

        ////////////////////////////////////
        // total 
        ////////////////////////////////////

        const baseTotalDiv = Page.createElement('div', parentElement, null, 'mine-damage-panel-main-section');
        const baseTotalHeader = Page.createElement('div', baseTotalDiv, null, 'mine-damage-panel-section-header');
        baseTotalHeader.innerHTML = 'Total Damage';

        this.baseTotalBody = Page.createElement('div', baseTotalDiv, null, 'mine-damage-panel-section-body');

        super.initializeView();        
    }

    /**
     * @override
     */
    updateViewContents() {

        const totalDamagePerTurn = this.damage.totalPickDamagePerTurn;

        if (!this.totalDamageString || !totalDamagePerTurn.equals(this.displayedTotalDamage)) {
            this.displayedTotalDamage.copy(totalDamagePerTurn);
            this.workingNum.copy(totalDamagePerTurn);
            this.workingNum.mul(this.turnsPerSecond);
            this.totalDamageString = NumberFormatter.formatBigNum(this.workingNum);
    
            this.baseTotalBody.innerHTML = this.totalDamageString + '/Sec';
        }
    }

}